import React from 'react'
import { Link } from 'react-router-dom'
import { Card } from '@/common/ui/Card'
import Logo from '@/common/ui/Navbar/logo.svg'
import { Button } from '@/common/ui/Form/Button'
import { ROUTES } from '@/app/app/routing/routes'

const NotFoundPage: React.FC = () => {
    return (
        <div className='min-h-screen bg-base-100 px-2'>
            <div className='flex min-h-screen items-center justify-center'>
                <div className='flex flex-col items-center justify-center gap-[3.125rem]'>
                    <Link to={ROUTES.APP} aria-label='Перейти на главную'>
                        <Logo className='h-[30px] w-[165px]' />
                    </Link>
                    <Card>
                        <div className='w-[23.125rem] flex flex-col items-center text-center gap-[1.875rem]'>
                            <div className='flex flex-col gap-2'>
                                <span className='text-6xl font-semibold leading-none text-base-content/20'>404</span>
                                <h1 className='text-[1.25rem] font-medium'>Страница не найдена</h1>
                                <p className='text-sm text-base-content/70'>
                                    К сожалению, запрашиваемая страница не существует или была перемещена.
                                </p>
                            </div>
                            <Button
                                type='button'
                                variant='filled'
                                emphasis='accent'
                                size='xl'
                                className='w-full'
                                as={Link}
                                to={ROUTES.APP}
                                aria-label='Вернуться на главную страницу'
                            >
                                Вернуться на главную
                            </Button>
                        </div>
                    </Card>
                </div>
            </div>
        </div>
    )
}

export default NotFoundPage
